var u = /* @__PURE__ */ ((M) => (M.NONE = "0", M.CUSTOM = "custom", M.TEENIE = "8px", M.SMALL = "16px", M.MEDIUM = "24px", M.LARGE = "32px", M.BIGGIE = "48px", M))(u || {}), E = /* @__PURE__ */ ((M) => (M.CUSTOM = "custom", M.FULL = "full", M.MEDIUM = "medium", M.SMALL = "small", M))(E || {}), L = /* @__PURE__ */ ((M) => (M.COLUMN = "column", M.ROW = "row", M))(L || {});
export {
  u as C,
  E as a,
  L as b
};
//# sourceMappingURL=enums-BtUzbEmn.mjs.map
